import Types from "@Types";

const reducer = (state = [], action) => {
    switch (action.type) {
        //? insert 
        case 'InsertMessage':
            const filteredState = state.filter(x => x.Series !== action.payload.Series);
            return [...filteredState, action.payload];
            
        case Types.clear:
            return [];
            
        case 'DeleteMessage':
            return state.filter((x) => x.Series !== action.payload);
            
        case 'SetMessage':
            return action.payload ?? [];
            case 'FetchMore':
            const newMessages = action.payload.filter(newMsg => 
                !state.some(existingMsg => existingMsg.Series === newMsg.Series)
            );
            return [...newMessages, ...state];
            
        default:
            return state;
    }
};
export default reducer;